import React from 'react';
import Css from './Header.module.css'

export default function Header() {
  return <header className={Css.container} id="Home">
      <a className={Css.tabs} href="#About">About</a>
      <a className={Css.tabs} href="#Skills">Skills</a>
      <a className={Css.tabs} href="#Work">Work</a>
      <a className={Css.tabs} href="#Contacts">Contacts</a>
  </header>;
}
